export const GET_ORGANIZATION_CHART = "GET_ORGANIZATION_CHART";
export const GET_ORGANIZATION_CHART_SUCCESS = "GET_ORGANIZATION_CHART_SUCCESS";
export const GET_ORGANIZATION_CHART_FAIL = "GET_ORGANIZATION_CHART_FAIL";

export const ADD_ORGANIZATION_CHART = "ADD_ORGANIZATION_CHART";
export const ADD_ORGANIZATION_CHART_SUCCESS = "ADD_ORGANIZATION_CHART_SUCCESS";
export const ADD_ORGANIZATION_CHART_FAIL = "ADD_ORGANIZATION_CHART_FAIL";

export const UPDATE_ORGANIZATION_CHART = "UPDATE_ORGANIZATION_CHART";
export const UPDATE_ORGANIZATION_CHART_SUCCESS = "UPDATE_ORGANIZATION_CHART_SUCCESS";
export const UPDATE_ORGANIZATION_CHART_FAIL = "UPDATE_ORGANIZATION_CHART_FAIL";

export const DELETE_ORGANIZATION_CHART = "DELETE_ORGANIZATION_CHART";
export const DELETE_ORGANIZATION_CHART_SUCCESS = "DELETE_ORGANIZATION_CHART_SUCCESS";
export const DELETE_ORGANIZATION_CHART_FAIL = "DELETE_ORGANIZATION_CHART_FAIL";

export const SET_ORGANIZATION_CHART_FIELD_ERRORS = "SET_ORGANIZATION_CHART_FIELD_ERRORS";
